import { User } from '@leap4/auth';
import { AnyAction } from 'redux';
import {
  USER_ERROR,
  GET_USER_BY_ID,
  CLEAR_USER,
  ADD_USER,
  UPDATE_USER,
  GET_ALL_USERS,
  CLEAR_USERS,
  DELETE_USER,
  USER_REDUCER_LOADING_USER_TRUE,
} from '../actions/types';
import { UsersGState } from '../interfaces/user-global-state.interface';

//set the store state properties of user
const initialState: UsersGState = {
  user: undefined,
  users: [],
  bIsLoading: true,
  loadingUser: true,
  error: undefined,
};

export default function (state: UsersGState = initialState, action: AnyAction):UsersGState {
  //takes from the action the type and the payload
  const { type, payload } = action;

  switch (type) {
    case GET_USER_BY_ID:
      return {
        ...state /**the current state */,
        user: payload /**the choosen user  (when admin edit user details) */,
        loadingUser: false,
      };

    case USER_REDUCER_LOADING_USER_TRUE:
      return {
        ...state,
        loadingUser: true,
      };

    case ADD_USER:
      return {
        ...state,
        bIsLoading: false,
      };

    case UPDATE_USER:
      return {
        ...state,
        bIsLoading: false,
      };

    case GET_ALL_USERS:
      return {
        ...state,
        users: payload /** all the users from the payload object */,
        bIsLoading: false,
      };

    case USER_ERROR:
      return {
        ...state,
        error: payload,
        bIsLoading: false,
        user: null,
      };

    case DELETE_USER:
      return {
        ...state,
        //removes from the users array the user that the admin removed
        users: state.users.filter(
          (user: User) =>
            user._id !==
            payload /**the payload is just the user id */,
        ) /**return to the state the users list without the user that has been removed */,
        bIsLoading: false,
      };

    case CLEAR_USERS:
      return {
        ...state,
        users: null /**clean the user array from the state */,
        bIsLoading: false,
      };

    case CLEAR_USER:
      return {
        ...state,
        user: null /**clean the user  from the state  */,
        bIsLoading: false,
      };

    default:
      return state;
  }
}
